import { Box, Button, Link, Spinner, Tooltip } from '@chakra-ui/react'
import { Icon } from 'components/atoms/Icon'
import { IconName } from 'components/atoms/Icon/types'
import { useAuthContext } from 'contexts/auth'
import React, { useEffect, useState } from 'react'
import { Link as LinkRouter } from 'react-router-dom'
import { NavigationList } from './constants'
import { NavigationProps } from './interfaces'

export const Navigation: React.FC<NavigationProps> = ({ redirect, isOpen }) => {
    const handleClick = () => {
        redirect && redirect()
    }

    const { loadingAuth } = useAuthContext()
    const [addMargin, setAddMargin] = useState(false)

    useEffect(() => {
        const sidebarIcon = document.querySelector(
            '[data-testid="sidebar-header"]'
        )
        const sidebar = document.querySelector('[data-testid="sidebar"]')

        sidebarIcon?.addEventListener('click', () => {
            {
                setTimeout(() => {
                    if (sidebar?.hasAttribute('open')) {
                        setAddMargin(true)
                    } else {
                        setAddMargin(false)
                    }
                }, 100)
            }
        })
    }, [])

    return (
        <>
            {loadingAuth ? (
                <Box height="100vh">
                    <Spinner
                        color="primary.500"
                        size="sm"
                        position="relative"
                        left="calc(50% - 17px)"
                        top="calc(50% - 270px)"
                        speed="1s"
                    />
                </Box>
            ) : (
                NavigationList().map((list, key) => (
                    <Link
                        data-testid={`navigation-link-${key}`}
                        key={key}
                        as={LinkRouter}
                        to={list.href}
                        _hover={{ textDecoration: 'none' }}
                        onClick={handleClick}
                    >
                        <Tooltip
                            label={list.label}
                            placement="right"
                            isDisabled={isOpen}
                        >
                            <Button
                                data-testid="navigation-button"
                                colorScheme="off-white"
                                color="inherit"
                                justifyContent="flex-start"
                                alignItems="center"
                                columnGap={4}
                                display="flex"
                                leftIcon={
                                    <Icon
                                        name={list.icon as IconName}
                                        color="initial"
                                    />
                                }
                                iconSpacing={0}
                                size="md"
                                fontSize="sm"
                                w="full"
                                mt={6}
                                p={2}
                                _hover={{ bg: 'gray.50', color: 'primary.600' }}
                            >
                                <Box
                                    marginTop={
                                        list.icon === 'house' && addMargin
                                            ? '7px'
                                            : ''
                                    }
                                >
                                    {list.label}
                                </Box>
                            </Button>
                        </Tooltip>
                    </Link>
                ))
            )}
        </>
    )
}
